import { ref } from 'vue';

// Module-level (singleton) ref: a lightweight bridge that lets any message
// bubble ask the product catalog sidebar to open showing a specific product,
// without needing a shared parent or a busy event race on mount.
const pendingProduct = ref(null);
const pendingCatalogAction = ref(null);

export function useProductCatalogLauncher() {
  const requestProductDetail = product => {
    pendingProduct.value = product;
  };

  const requestCatalogAction = action => {
    pendingCatalogAction.value = action;
  };

  const consumePendingProduct = () => {
    const product = pendingProduct.value;
    pendingProduct.value = null;
    return product;
  };

  const consumePendingCatalogAction = () => {
    const action = pendingCatalogAction.value;
    pendingCatalogAction.value = null;
    return action;
  };

  return {
    pendingProduct,
    pendingCatalogAction,
    requestProductDetail,
    requestCatalogAction,
    consumePendingProduct,
    consumePendingCatalogAction,
  };
}
